import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.show
    ? _c(
        "div",
        {
          class: { fullscreen: _vm.fullscreen, div: _vm.overlay || _vm.center },
          style: _vm.overlay ? _vm.overlayBackground : "",
        },
        [
          _c(
            "div",
            {
              class: { "fullscreen-loader": _vm.fullscreen },
              style: _vm.loaderAdjustment,
            },
            [
              _vm._t("loader", function () {
                return [
                  _vm._v(
                    "\n      " + _vm._s((_vm.defaultLoader = true)) + "\n      "
                  ),
                  _c(VProgressCircular, {
                    attrs: { indeterminate: "", color: "primary" },
                  }),
                ]
              }),
            ],
            2
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }